import styled from 'styled-components';
import { Space } from '@10d/tend-ui-grid';
import { Button as DefaultButton } from '@10d/tend-ui/primitives';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { Text, Title as DefaultTitle } from 'ui/components/Typography';

import WhaleSpot from 'assets/img/whaleBgSpot.svg';
import WhaleFail from 'assets/img/whaleFail.svg';

export const Title = styled(DefaultTitle)`
  && {
    color: ${colors.gray900};
    margin-bottom: 16px;
  }
`;

export const Button = styled(DefaultButton)`
  && {
    margin-top: 32px;
  }
`;

export const WhaleImage = styled.img`
  max-width: 157px;
  margin-bottom: 10px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: auto;
  justify-content: center;
  height: inherit;
  min-height: 400px;
`;

export const VerticalWrapper = styled(Space)`
  width: 100%;
  text-align: center;
  height: inherit;
  justify-content: center;
`;

export const Illustration = styled.div`
  background: url(${WhaleSpot}) no-repeat;
  width: 336px;
  height: 317px;

  &:after {
    content: '';
    background: url(${WhaleFail}) no-repeat center center;
    width: 100%;
    height: 100%;
    display: block;
  }
`;

export const Content = styled.div<{ withoutIndent?: boolean }>`
  margin-left: ${props => (props.withoutIndent ? 0 : 64)}px;
  position: relative;
`;

export const Schedule = styled(Text)`
  font-size: 12px;
  color: ${colors.gray650};
`;

export const Image404 = styled.img`
  position: absolute;
  max-width: 70%;
`;
